var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { Row, Col } from "react-bootstrap";
import moment from "moment";
import { FormattedMessage } from "@irati/utils/lang";
import { H6 } from "@irati/ui/src/Typography";
import Flex from "@irati/ui/src/Flex";
import Button from "@irati/ui/src/Button";
var UserLinkedCard = /** @class */ (function (_super) {
    __extends(UserLinkedCard, _super);
    function UserLinkedCard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UserLinkedCard.prototype.render = function () {
        var _a = this.props, card = _a.card, lastFour = _a.lastFour, expMonth = _a.expMonth, expYear = _a.expYear, onClick = _a.onClick;
        return (React.createElement(Row, null,
            React.createElement(Col, { xs: 6 },
                React.createElement(H6, null,
                    "**** **** **** ",
                    lastFour)),
            React.createElement(Col, { xs: 3 },
                React.createElement(Flex, { justifyContent: "flex-end" },
                    React.createElement(H6, null, moment(new Date(expYear, expMonth - 1, 1)).format("MM/YY")))),
            React.createElement(Col, { xs: 3 },
                React.createElement(Flex, { justifyContent: "flex-end", onClick: function () { return onClick(card); } },
                    React.createElement(Button, { destructive: true },
                        React.createElement(FormattedMessage, { id: "account.linkedCards.remove" }))))));
    };
    return UserLinkedCard;
}(PureComponent));
export default UserLinkedCard;
